import { ScrollReveal, Overline } from "./Reveal";

const IMG_PERFORMANCE =
  "https://images.unsplash.com/photo-1720462393492-046dfa56b1d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHxtYW4lMjBydW5uaW5nJTIwY2xvc2UlMjB1cCUyMGZhY2V8ZW58MHx8fHwxNzkwNTYzODQzfDA&ixlib=rb-4.1.0&q=85";
const IMG_SLEEP =
  "https://images.unsplash.com/photo-1775128081807-bf80342c7ce1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHw0fHxzbGVlcGluZyUyMGF0aGxldGUlMjByZWNvdmVyeSUyMGRhcmslMjByb29tfGVufDB8fHx8MTc4NjM1MzM2NXww&ixlib=rb-4.1.0&q=85";

const ChapterNumber = ({ n }) => (
  <span className="font-anton text-5xl md:text-7xl text-white/15 leading-none">{n}</span>
);

const Manifesto = () => (
  <section
    id="manifesto"
    data-testid="manifesto-section"
    className="relative py-28 md:py-40 px-6 md:px-10 max-w-[1600px] mx-auto"
  >
    <ScrollReveal>
      <Overline className="mb-4">Why Breethe</Overline>
      <h2 className="font-anton uppercase text-4xl md:text-6xl leading-[0.9] max-w-3xl">
        Breathing is a skill.
        <br />
        <span className="text-white/40">Most people suck at it.</span>
      </h2>
    </ScrollReveal>

    <div className="mt-20 md:mt-28 grid grid-cols-1 lg:grid-cols-12 gap-12 md:gap-16">
      <ScrollReveal className="lg:col-span-7" data-testid="chapter-performance">
        <div data-testid="chapter-performance" className="group">
          <div className="flex items-start justify-between border-t border-white/10 pt-6">
            <ChapterNumber n="01" />
            <span className="font-plex text-xs uppercase tracking-[0.25em] text-volt mt-2">
              +38% Airflow
            </span>
          </div>
          <h3 className="font-anton uppercase text-3xl md:text-5xl mt-6 leading-[0.9]">
            Open the engine
          </h3>
          <p className="mt-5 text-white/60 font-light leading-relaxed max-w-lg text-base md:text-lg">
            Spring-loaded flex bands lift your nasal passages open the second
            the strip touches skin. More oxygen per breath, every breath, for
            as long as you wear it.
          </p>
          <div className="mt-8 overflow-hidden border border-white/10 clip-frame">
            <img
              src={IMG_PERFORMANCE}
              alt="Man running at speed through the city, cinematic motion blur"
              data-testid="chapter-performance-image"
              className="w-full h-64 md:h-96 object-cover grayscale contrast-125 transition-transform duration-700 group-hover:scale-105"
            />
          </div>
        </div>
      </ScrollReveal>

      <ScrollReveal delay={0.15} className="lg:col-span-5 lg:mt-32">
        <div data-testid="chapter-sleep" className="group">
          <div className="flex items-start justify-between border-t border-white/10 pt-6">
            <ChapterNumber n="02" />
            <span className="font-plex text-xs uppercase tracking-[0.25em] text-volt mt-2">
              0 Snores
            </span>
          </div>
          <h3 className="font-anton uppercase text-3xl md:text-5xl mt-6 leading-[0.9]">
            Sleep sound and wake up fresh
          </h3>
          <p className="mt-5 text-white/60 font-light leading-relaxed text-base md:text-lg">
            Mouth closed. Airway open. Breethe kills snoring and keeps oxygen
            intake high all night, so you wake up fresh — not groggy.
          </p>
          <div className="mt-8 overflow-hidden border border-white/10 clip-frame">
            <img
              src={IMG_SLEEP}
              alt="Athlete recovering in a dim room"
              data-testid="chapter-sleep-image"
              className="w-full h-64 md:h-80 object-cover grayscale contrast-125 transition-transform duration-700 group-hover:scale-105"
            />
          </div>
        </div>
      </ScrollReveal>

      <ScrollReveal delay={0.1} className="lg:col-span-8 lg:col-start-5 lg:-mt-6">
        <div data-testid="chapter-recovery" className="border border-white/10 p-8 md:p-12 bg-[#121212]">
          <div className="flex items-start justify-between">
            <ChapterNumber n="03" />
            <span className="font-plex text-xs uppercase tracking-[0.25em] text-volt mt-2">
              12H Hold
            </span>
          </div>
          <h3 className="font-anton uppercase text-3xl md:text-5xl mt-6 leading-[0.9]">
            Oxygen is the recovery plan
          </h3>
          <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-8">
            <p className="text-white/60 font-light leading-relaxed text-base md:text-lg">
              More O₂ per breath means fatigue flushes faster. Wear it on the
              run, in the gym, in bed. Recover like it's your job.
            </p>
            <ul className="font-plex text-xs uppercase tracking-[0.2em] text-white/50 space-y-3">
              <li className="flex justify-between border-b border-white/10 pb-2">
                <span>Sweat-proof hold</span>
                <span className="text-white">12H</span>
              </li>
              <li className="flex justify-between border-b border-white/10 pb-2">
                <span>Nasal opening</span>
                <span className="text-white">+38%</span>
              </li>
              <li className="flex justify-between border-b border-white/10 pb-2">
                <span>Batteries required</span>
                <span className="text-volt">None</span>
              </li>
            </ul>
          </div>
        </div>
      </ScrollReveal>
    </div>
  </section>
);

export default Manifesto;
